import { Card, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { Overlay } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { useResultPageContext } from '../../v3/contexts/ResultPageContext';
import FiltersButtons from './FiltersButtons';
import FilterContent from './FilterContent';
import type { Filters } from './MobileFilters';

const FiltersOverlayFooter = css`
  border-top: 1px solid ${vars.colors.inputs.main};
`;

interface DesktopDrawerFiltersProps {
  onClear: () => void;
  onFilter: (filterOptions: { [key: string]: string[] | null | string }) => void;
  selectedFilters?: Filters;
}

const DesktopDrawerFilters = ({
  onClear,
  onFilter,
  selectedFilters,
}: DesktopDrawerFiltersProps) => {
  const { t } = useTranslation();
  const { isFiltersPanelOpen, closeFiltersPanel } = useResultPageContext();

  return (
    <Overlay.Drawer
      dataTestId="resultPage-filtersDrawerContainer"
      handleClose={closeFiltersPanel}
      isOpen={isFiltersPanelOpen}
      shouldOpenHorizontally
    >
      <Overlay.Header
        onClose={closeFiltersPanel}
        title={t('Responsive.Air.Result.Filter.Button.Filter')}
      />
      <Overlay.Content>
        <Card>
          <FilterContent onFilter={onFilter} selectedFilters={selectedFilters} />
        </Card>
      </Overlay.Content>
      <Overlay.Footer className={FiltersOverlayFooter}>
        <FiltersButtons onClear={onClear} />
      </Overlay.Footer>
    </Overlay.Drawer>
  );
};

export default DesktopDrawerFilters;
